import {Button, styled} from "@mui/material";

export const FilterButton = styled(Button)(({theme}) => ({
    color: theme.palette.text.primary,
    height: '3rem',

    borderRadius: '50%',
    justifyContent: 'center',
    minWidth: '3rem',
    minHeight: '3rem',
    alignItems: 'center',
    display: 'flex',
    padding: 0,

    '&:hover': {
        backgroundColor: 'unset'
    },
}));

export const FilterButtonOpened = styled(FilterButton)(({theme}) => ({
    backgroundColor: theme.barekam.filter.buttons.filterMain.backgroundColor,
    '&:hover': {
        backgroundColor: theme.barekam.filter.buttons.filterMain.backgroundColor,
    },
    '& img': {
        filter: 'brightness(1000%) saturate(0%) contrast(1000%)'
    }
}))

export const FilterButtonSecondary = styled(Button)(({theme}) => ({
    color: theme.palette.text.primary,

    borderRadius: '3rem',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',

    '&:hover': {
        backgroundColor: theme.barekam.filter.buttons.filterSecondary.backgroundHoverColor
    }
}));

export const FilterButtonSecondaryOpened = styled(FilterButtonSecondary)(() => ({
    background: '#FFF',
    borderRadius: '1.5rem',
    boxShadow: '0px 0px 4px 0px rgba(69, 77, 102, 0.50) inset'
}))

// Filter chip
export const ChipClearAll = styled(Button)(() => ({
    minWidth: 0
}));